<div class="container" [ngClass]="size" [style.background-image]="image | base64">
</div>